import { useCallback } from 'react'

import { noop } from 'lodash'
import { useDispatch, useSelector } from 'react-redux'

import api from 'common/api'
import { selectId, actions as userActions } from 'store/user'

export const useSaveCareer = () => {
  const dispatch = useDispatch()
  const userId = useSelector(selectId)

  return useCallback(
    (soc: string, name: string) => {
      return api
        .post(`/api/student_careers/${userId}`, [
          {
            SOC: soc,
            Title: name,
            Origin: 'manual',
          },
        ])
        .catch(noop)
        .then(() => {
          dispatch(userActions.fetchUser())
        })
    },
    [userId, dispatch],
  )
}

export const useUnsaveCareer = () => {
  const dispatch = useDispatch()
  const userId = useSelector(selectId)

  return useCallback(
    (soc: string) => {
      return api
        .delete(`/api/student_careers/${userId}/career/${soc}`)
        .catch(noop)
        .then(() => {
          dispatch(userActions.fetchUser())
        })
    },
    [userId, dispatch],
  )
}
